module.exports = __webpack_public_path__ + "media/images/frontend/twitter-56d52c5577c4cbeb07fa52b73c616633.png";